export default {
  modalId: {
    type: String,
    requried: true,
  },
}
